/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Box, Grid } from '@mui/material';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import OktaUsers from '../views/OktaUsers';
import OktaUserCreation from '../views/OktaCreationUser';
const ManageOktaPage = () => {
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Okta Users'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6}>
                        <OktaUserCreation />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <OktaUsers />
                    </Grid>
                </Grid>
            </Box>

        </>
    )
}

export default ManageOktaPage;